<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">

      <artisio-modal :visible="showTaxRateModal" :data="model" :title="$t('Tax Rate')" @show="onShow" size="sm"
                     @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                     :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <input-widget :label="false" :model="model" attribute="tax_rate" type="number" autofocus/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import TaxRateForm from "@/modules/customer/models/TaxRateForm.model";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TaxRateModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new TaxRateForm()
      }
    },
    computed: {
      ...mapState({
        showTaxRateModal: state => state.view.taxRateModal.show,
        editObject: state => state.view.taxRateModal.object,
        inventory: state => state.view.taxRateModal.inventory,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject) {
          this.model = new TaxRateForm({
            tax_rate: this.editObject.tax_rate,
          })
        }
      }
    },
    methods: {
      ...mapActions(['hideTaxRateModal', 'updateInventoryTerms']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }

        this.loading = true;
        let tmpData = this.model.toJSON()

        let
            response = await this.updateInventoryTerms({
              uuid: this.inventory.uuid,
              data: {
                tax_rate: tmpData.tax_rate,
              }
            });
        this.loading = false;

        if (response.success) {
          this.hideTaxRateModal();
          this.$toast('success', this.$t('Tax Rate were successfully saved'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
      ,
      onShow() {
        this.showConfirmation = true;
      }
      ,
      onHidden() {
        this.model = new TaxRateForm();
        this.hideTaxRateModal();
      }
      ,
    }
  }
</script>

<style lang="scss" scoped>
</style>

